export default IconCurrencyPeso => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-currency-peso" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M8 19v-14h3.5a4.5 4.5 0 1 1 0 9h-3.5" />
  <path d="M18 8h-12" />
  <path d="M18 11h-12" />
</svg>`;